import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchSweetShopArticleCategories } from '../../api/fetch-sweet-shop-article-categories';

export const fetchSweetShopArticleCategoriesThunk = createAsyncThunk(
    'fetchSweetShopArticleCategories',
    async () => fetchSweetShopArticleCategories(),
);
